import {module} from "../app";
import * as _ from 'lodash';

module.service("pingSvc", [
  "$http",
  function ($http) {
    var lastPing = null;

    var ping = function (url) {
      if (lastPing)
        return lastPing;

      lastPing = $http.get(_.trim(url, "/") + "/api/configuration/getServerTime")
        .then(function () {
          setTimeout(function () {
            lastPing = null
          }, 5000);
        })
        .catch(function (error) {
          lastPing = null;
          throw error;
        });

      return lastPing;
    };

    let pingTest = async function (url, times) {
      const startTime = new Date();

      const timesToPing = times || 5;

      let pingResults = [];
      let index = 0;
      while (pingResults.length < timesToPing) {
        index++;
        const appendVariable = index % 3 === 0 ? '1' : 'testPing2';
        const urlToConnect = `${_.trim(url, "/")}/api/configuration/getServerTime?_=${ appendVariable }&indexRequest=${index}`;

        pingResults.push($http.get(urlToConnect));
        console.log(`Request to url ${urlToConnect} made`);
      }

      await Promise.all(pingResults);
      const pingFinished = new Date();
      const duration = moment(pingFinished).diff(startTime);
      const message = `v2 Pinged the server ${times} time(s) and took ${duration}ms`;

      const urlToLog = `${_.trim(url, "/")}/api/logging/logMessage`;
      $http.post(urlToLog, {message: message})

      return {
        startTime,
        finished: pingFinished,
        duration: duration,
        message: message
      };
    };

    return {
      ping: ping,
      pingTest
    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/services/ping.js